Namespace 'Customer.Ticket'

class Customer.Ticket.InstagramResponseStickerSelectorView extends Backbone.View
  className: 'instagram-response-sticker-selector'
  template: JST['backbone/templates/customer/ticket/sticker/instagram_response_sticker_selector']
  placeHolderStickerTemplate: JST['backbone/templates/customer/ticket/sticker/instagram_placeholder_sticker']

  render: ->
    @$el.html(@template())
    @heartSticker = @_heartSticker()
    @listenTo @heartSticker, 'sticker:clicked', (name) => @_selectSticker(name)
    @$el.find('.stickers-container').append(@heartSticker.render().el)
    @$el.find('.stickers-container').append(@placeHolderStickerTemplate())
    @$el.find('.stickers-container').append(@placeHolderStickerTemplate())
    @$el.find('.stickers-container').append(@placeHolderStickerTemplate())
    @disable()
    @

  enable: ->
    @$el.find('.sections').show()

  disable: ->
    @$el.find('.sections').hide()

  _selectSticker: (name) ->
    @disable()
    @trigger 'add:sticker', name

  _heartSticker: ->
    new Customer.Ticket.InstagramStickerView('like_heart')
